import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {add, deleteAllRecords, deleteRecord, fetch, fetchRecords, update,} from 'services/SigninOptionsService';

import {
    deleteAllCase,
    deleteOneCase,
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from 'store/RecordsSliceCaseHelpers';

const entityKey = 'signinOptions';

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
};

const normalizeRecord = (record) => {
    return Object.assign({}, record, {
        id: record.id,
    });
};

// genenrates pending, fulfilled and rejected
export const fetchSigninOptions = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    (query) => {
        return fetchRecords(query).then((response) => {
            return response.map((record) => {
                return normalizeRecord(record);
            });
        });
    }
);

export const fetchSigninOption = createAsyncThunk(
    `${entityKey}/fetch`,
    (id) => {
        return fetch(id).then((response) => {
            return normalizeRecord(response.data);
        });
    }
);

export const saveSigninOption = createAsyncThunk(
    `${entityKey}/add`,
    (payload) => {
        return add(payload).then((response) => response);
    }
);

export const updateSigninOption = createAsyncThunk(
    `${entityKey}/update`,
    ({id, record}) => {
        return update(id, record).then(() => record);
    }
);

export const deleteSigninOption = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    (id) => {
        return deleteRecord(id).then(() => id);
    }
);

export const deleteAllSigninOptions = createAsyncThunk(
    `${entityKey}/deleteAllRecords`,
    () => {
        return deleteAllRecords().then((response) => response);
    }
);

const applicationsSlice = createSlice({
                                          name: entityKey,
                                          initialState,
                                          extraReducers: (builder) => {
                                              // FETCH MANY
                                              fetchManyCase(builder, fetchSigninOptions, entityKey);

                                              // FETCH ONE
                                              fetchOneCase(builder, fetchSigninOption);

                                              // SAVE ONE
                                              saveOneCase(builder, saveSigninOption);

                                              // UPDATE ONE
                                              updateOneCase(builder, updateSigninOption);

                                              // DELETE ONE
                                              deleteOneCase(builder, deleteSigninOption);

                                              // DELETE ALL
                                              deleteAllCase(builder, deleteAllSigninOptions);
                                          },
                                      });

export default applicationsSlice.reducer;
